import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import PrivateRoute from "../../components/routing/PrivateRoute";
import UserInfoPage from "./pages/UserInfoPage";
import NavBar from "./components/NavBar";
import { connect } from "react-redux";
import "../../round.css";
import "../../color.css";
import "./layout2.css";

import SearchDevice from "../../components/device/SearchDevice";
import SearchModel from "../../components/device/SearchModel";
import FotaJobs from "../../components/dashboard/FotaJobs";
import Statistics from "../../components/dashboard/Statistics";
import ProductMetrics from "../../components/dashboard/ProductMetrics";
import FeedbackStatistics from "../../components/dashboard/FeedbackStatistics";
import FirmwareInfo from "../report/FirmwareInfo";
import FeedbackPage from "./pages/FeedbackPage";
import MetricsCharts from "./pages/MetricsCharts";
import ManufacturedDevicesPage from "./pages/ManufacturedDevicesPage";
import AddNewDeviceModel from "../../components/device/AddNewDeviceModel";
import IDUEEPROMConfig from "../../components/device/IDUEEPROMConfig/IDUConfig";
import customConfig from "../../config";
import DeviceDealerMgmt from "../../components/deviceDealerMgmt/deviceDealerMgmt";

import QRCode from "../qrcode/qrcode";
import DeviceFirmware from "../device/DeviceFirmware/Firmware";
import LineTestUserSearchDevice from "../LineTestUser/SearchDevice";
import NotificationManagement from "../notificationManagement";
import InAppNotificationPage from "../../pages/InAppNotificationPage";
import CreateNotificationPage from "../../pages/CreateNotificationPage";
import EditNotificationPage from "../../pages/EditNotificationPage";
import ViewNotificationPage from "../../pages/ViewNotificationPage";
import DACStatistics from "../device/DACStatistics/DACStatistics";
import Landing from "../landing/Landing";
import AssetManagement from "../assetManagement/AssetManagement";

const Layout2Routes = ({ isAuthenticated, userLevel, userRoles }) => {

  const dashboardRoute = () => {
    if (userRoles && userRoles.includes(customConfig.roleLineTestUser)) {
      return <LineTestUserSearchDevice />;
    }

    if (
      (userLevel === 0 && userRoles?.includes(customConfig.roleFactoryAdmin)) ||
      userRoles?.includes(customConfig.roleFieldOperator)
    ) {
      return <SearchModel wrapperClass="content-wrapper" />;
    }

    return <UserInfoPage />;
  };

  return (
    <div className="new-layout-wraper">
      {isAuthenticated && <div> <NavBar /> </div>}

      <Routes>

        {/* Protected Routes */}
        <Route element={<PrivateRoute />}>

          <Route path="/landing" element={<Landing />} />

          <Route path="/dashboard" element={dashboardRoute()} />

          <Route
            path="/searchDevice"
            element={<SearchDevice wrapperClass="content-wrapper" />}
          />

          <Route
            path="/deviceDetail"
            element={<SearchModel wrapperClass="content-wrapper" />}
          />

          <Route
            path="/deviceDetail/:modelNum"
            element={<SearchModel wrapperClass="content-wrapper" />}
          />

          <Route
            path="/statistics"
            element={<Statistics wrapperClass="content-wrapper" />}
          />

          <Route
            path="/productMetrics"
            element={<ProductMetrics wrapperClass="content-wrapper" />}
          />

          <Route
            path="/feedback-statistics"
            element={<FeedbackStatistics wrapperClass="content-wrapper" />}
          />

          <Route
            path="/fotaJobs"
            element={<FotaJobs wrapperClass="content-wrapper" />}
          />

          <Route
            path="/manufacturedDevices"
            element={<ManufacturedDevicesPage wrapperClass="content-wrapper" />}
          />

          <Route
            path="/firmwareInfo"
            element={<FirmwareInfo wrapperClass="content-wrapper" />}
          />

          <Route
            path="/feedback"
            element={<FeedbackPage wrapperClass="content-wrapper" />}
          />

          <Route
            path="/metricsChart"
            element={<MetricsCharts wrapperClass="content-wrapper" />}
          />

          <Route
            path="/addNewDeviceModel"
            element={<AddNewDeviceModel wrapperClass="content-wrapper" />}
          />

          <Route
            path="/idueepromConfig"
            element={<IDUEEPROMConfig wrapperClass="content-wrapper" />}
          />

          <Route
            path="/qrcode"
            element={<QRCode wrapperClass="content-wrapper" />}
          />

          <Route
            path="/deviceFirmware"
            element={<DeviceFirmware wrapperClass="content-wrapper" />}
          />

          <Route
            path="/deviceDealer"
            element={<DeviceDealerMgmt wrapperClass="content-wrapper" />}
          />

          <Route
            path="/notification"
            element={<NotificationManagement wrapperClass="content-wrapper" />}
          />

          <Route path="/inapp-notifications" element={<InAppNotificationPage />} />
          <Route path="/inapp-notifications/create" element={<CreateNotificationPage />} />
          <Route
            path="/inapp-notifications/edit/:notificationId"
            element={<EditNotificationPage />}
          />
          <Route
            path="/inapp-notifications/view/:notificationId"
            element={<ViewNotificationPage />}
          />
          <Route
            path="/app-support/in-app-notifications"
            element={<Navigate to="/inapp-notifications" replace />}
          />
          <Route
            path="/app-support/in-app-notifications/create"
            element={<Navigate to="/inapp-notifications/create" replace />}
          />
          <Route
            path="/app-support/in-app-notifications/edit/:notificationId"
            element={<Navigate to="/inapp-notifications/edit/:notificationId" replace />}
          />
          <Route
            path="/inAppNotifications"
            element={<Navigate to="/inapp-notifications" replace />}
          />

          <Route
            path="/acFreqToPower"
            element={<DACStatistics wrapperClass="content-wrapper" />}
          />

          <Route
            path="/DACStatistics"
            element={<DACStatistics wrapperClass="content-wrapper" />}
          />

          <Route
            path="/assetManagement"
            element={<AssetManagement wrapperClass="content-wrapper" />}
          />

        </Route>

      </Routes>
    </div>
  );
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  userRoles: state.auth.userRoles,
  userLevel: state.auth.userLevel,
});

export default connect(mapStateToProps)(Layout2Routes);